import * as React from "react";
import {
  Typography,
  CircularProgress,
  DialogContentText,
  Grid,
  withStyles,
  LinearProgress,
  Button,
} from "@material-ui/core";
import CancelIcon from "@material-ui/icons/Cancel";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

const styles = () => ({
  container: { padding: "55px 10px 10px 10px" },
  progressLarge: {
    margin: 0,
    color: "#ABC200",
    width: "50px !important",
    height: "50px !important",
  },
  title: {
    fontSize: "0.875rem",
    fontWeight: 700,
    textTransform: "uppercase" as any,
    margin: "1rem 0 0.25rem 0",
  },
  progressBar: {
    width: "100%",
    height: 12,
    borderRadius: 10,
    margin: "1.5rem 0",
  },
  progressColorPrimary: {
    backgroundColor: "#E0E0E0",
  },
  progressBarColorPrimary: {
    backgroundColor: "#ABC200",
  },
  message: { fontWeight: 300, width: 250, textAlign: "center" as any },
});

export const LoadingLayer = withStyles(styles)(({ classes }: any) => (
  // <DialogContentText className={classes.container}>
  <Grid container direction="column" alignItems="center">
    <CircularProgress
      className={classes.progressLarge}
      variant="indeterminate"
    />
    <Typography className={classes.title}>
      {"Preparando importação..."}
    </Typography>
  </Grid>
  // </DialogContentText>
));

export const ProcessingLayer = withStyles(styles)(
  ({
    progress,
    time,
    classes,
  }: {
    progress: number;
    time: number;
    classes: any;
  }) => (
    // <DialogContentText className={classes.container}>
    <Grid container direction="column" alignItems="center">
      <Typography style={{ fontSize: "3rem", fontWeight: 300 }}>
        {`${progress}%`}
      </Typography>
      <Typography className={classes.title}>
        {"Estamos importando seu orçamento..."}
      </Typography>
      {/* <Typography variant="caption" style={{fontWeight: 300}}>
        {`Tempo restante estimado: ${time}h`}
      </Typography> */}
      <LinearProgress
        variant="determinate"
        value={progress}
        classes={{
          root: classes.progressBar,
          colorPrimary: classes.progressColorPrimary,
          barColorPrimary: classes.progressBarColorPrimary,
        }}
      />
      <Typography className={classes.message}>
        {
          "Você pode aguardar ou fechar esta aba e voltar novamente mais tarde quando seu orçamento estiver pronto."
        }
      </Typography>
    </Grid>
    // </DialogContentText>
  )
);

export const FinishedLayer = withStyles(styles)(
  ({ onClose, classes }: { onClose?: (ev: any) => void; classes: any }) => (
    // <DialogContentText className={classes.container}>
    <Grid container direction="column" alignItems="center" spacing={16}>
      <CheckCircleIcon style={{ color: "#0E8755", fontSize: "3.5rem" }} />
      <Typography
        className={classes.title}
        style={{ paddingTop: "1rem", paddingBottom: "1.7rem" }}
      >
        {"Orçamento importado com sucesso!"}
      </Typography>
      <Typography className={classes.message}>
        {"Seu orçamento está quase pronto, estamos calculando."}
        {/* {"Seu orçamento já está pronto para ser acessado e configurado."} */}
      </Typography>
      {/* <Button color="primary" onClick={onClose}>
        {"Concluir"}
      </Button> */}
    </Grid>
    // </DialogContentText>
  )
);

export const ErrorLayer = withStyles(styles)(
  ({
    onReset,
    onClose,
    message,
    classes,
  }: {
    onReset?: (ev: any) => void;
    onClose?: (ev: any) => void;
    message?: any;
    classes: any;
  }) => (
    // <DialogContentText className={classes.container}>
    <Grid container direction="column" alignItems="center" spacing={16}>
      <CancelIcon style={{ color: "#D73912", fontSize: "3.5rem" }} />
      <Typography className={classes.title}>
        {"Houve um erro ao importar seu orçamento!"}
      </Typography>
      <Grid
        container
        direction="column"
        alignItems="center"
        style={{ paddingTop: "1rem" }}
      >
        <Typography variant="caption" style={{ color: "#D73912" }}>
          {message}
        </Typography>
        {/* <Typography variant="caption" style={{color: "#D73912"}}>
          {"'Unidade' não pode estar vazio [Coluna G]"}
        </Typography> */}
      </Grid>
      <Typography
        className={classes.message}
        style={{
          paddingTop: "1rem",
          paddingBottom: "1.7rem",
          width: "375px !important",
        }}
      >
        {
          "Por favor, verifique se os dados da planilha estão preenchidos corretamente e tente de novo."
        }
      </Typography>
      <Button color="primary" onClick={onReset}>
        {"Tentar novamente"}
      </Button>
      <Button color="secondary" onClick={onClose}>
        {"Cancelar"}
      </Button>
    </Grid>
    // </DialogContentText>
  )
);



// WEBPACK FOOTER //
// ./src/modules/costPlan/components/layouts/LayersImportation.tsx